import { render, staticRenderFns } from "./TdocFields.vue?vue&type=template&id=1abdccce&"
import script from "./TdocFields.vue?vue&type=script&lang=ts&"
export * from "./TdocFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports